import type { SVGProps } from 'react';

interface DollarIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const DollarIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & DollarIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <circle cx={10} cy={10} fill="#4FA9FF" r={10} />
    <path
      d="M13.636 14.1a3.3 3.3 0 0 1-1.1 1.479q-.74.576-1.838.72-1.076.135-2.334-.281l-.498 1.315-1.044-.391.504-1.332q-1.674-.795-2.403-2.07-.723-1.29-.21-2.841l2.97 1.113q-.271 1.011.473 1.606l.97-2.566q-1.149-.803-1.8-1.398a3.6 3.6 0 0 1-.946-1.486q-.313-.897.135-2.082.56-1.479 1.991-1.961 1.447-.478 3.22.057l.498-1.315 1.044.391-.498 1.315q1.665.773 2.334 2.006.67 1.234.206 2.804l-2.986-1.12q.234-.914-.402-1.448l-.952 2.517q1.212.88 1.836 1.449.624.567.937 1.463.336.886-.107 2.056M9.518 6.863q-.154.406-.013.774.156.374.55.762l.854-2.257q-.488-.09-.853.088-.36.162-.538.633m-.337 6.995q.52.102.915-.103.41-.198.582-.653.16-.421-.019-.786-.156-.375-.605-.764z"
      fill="#F8F8F8"
    />
  </svg>
);
